<template>
  <div
    :class="[
      'bearing-picker',
      isSearchMode ? 'search-fulltext' : 'search-attrib',
    ]"
  >
    <div class="bearing-search-container">
      <template v-if="isSearchMode">
        <base-input
          @update:value="updateSearchTerm"
          name="Produktbezeichnung"
          ref="fulltext"
        />
      </template>
      <template v-else>
        <range-wrapper title="Innendurchmesser [d]">
          <template #from>
            <base-input
              @update:value="updateInnerMin"
              name="von [mm]"
              ref="firstparam"
            />
          </template>
          <template #to>
            <base-input @update:value="updateInnerMax" name="bis [mm]"
          /></template>
        </range-wrapper>
        <range-wrapper title="Aussendurchmesser [D]">
          <template #from>
            <base-input @update:value="updateOuterMin" name="von [mm]" />
          </template>
          <template #to>
            <base-input @update:value="updateOuterMax" name="bis [mm]"
          /></template>
        </range-wrapper>
        <range-wrapper title="Breite/Höhe [B/H]">
          <template #from>
            <base-input @update:value="updateWidthMin" name="von [mm]" />
          </template>
          <template #to>
            <base-input @update:value="updateWidthMax" name="bis [mm]" />
          </template>
        </range-wrapper>

        <two-column-wrapper titleLeft="Rostfrei" titleRight="Flansch">
          <template #left>
            <base-dropdown v-bind="yesNoIndexData" @update:value="updateRust" />
          </template>
          <template #right>
            <base-dropdown
              v-bind="yesNoIndexData"
              @update:value="updateFlange"
            />
          </template>
        </two-column-wrapper>

        <two-column-wrapper titleLeft="Dichtung" titleRight="Artikelgruppe">
          <template #left>
            <base-multiple-dropdown v-bind="filterSeal" @update:value="updateSeal" />
          </template>
          <template #right>
            <base-multiple-dropdown
              v-bind="filterCategory"
              @update:value="updateCategories"
            />
          </template>
        </two-column-wrapper>
        <one-column-wrapper title="Bezeichnung">
          <template #content>
            <base-input
              @update:value="updateSearchTerm"
              name="Suchwort"
              ref="fulltext"
            />
          </template>
        </one-column-wrapper>
      </template>

      <div class="results">
        <ul :class="['result-header']">
          <li class="header grouping">
            <span class="group_desc"></span>
            <span class="group_measurement">Abmessungen [mm]</span>
            <span class="group_more">Eigenschaften</span>
          </li>
          <li class="header">
            <span class="sugg_desc">
              <span class="name">Bezeichnung</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField == 'name' ? 'active' : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="sortList('name', true)"
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="sortList('name', false)"
                ></span>
              </span>
            </span>
            <!-- -->
            <span class="sugg_d">
              <span class="name">d</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField ==
                  'customFields.yuniqProductProperty_virtuell_innen_d'
                    ? 'active'
                    : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_virtuell_innen_d',
                      true
                    )
                  "
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_virtuell_innen_d',
                      false
                    )
                  "
                ></span>
              </span>
            </span>
            <span class="sugg_D">
              <span class="name">D</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField ==
                  'customFields.yuniqProductProperty_abm_gross_d'
                    ? 'active'
                    : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_abm_gross_d',
                      true
                    )
                  "
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_abm_gross_d',
                      false
                    )
                  "
                ></span>
              </span>
            </span>
            <span class="sugg_B">
              <span class="name">B/H</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField ==
                  'customFields.yuniqProductProperty_virtuell_abm_hoehe'
                    ? 'active'
                    : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_virtuell_abm_hoehe',
                      true
                    )
                  "
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_virtuell_abm_hoehe',
                      false
                    )
                  "
                ></span>
              </span>
            </span>
            <!-- -->
            <span class="sugg_flange">Flansch</span>
            <span class="sugg_seal">
              <span class="name">Dichtung</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField ==
                  'customFields.yuniqProductProperty_dic_dichtung_alternativtext'
                    ? 'active'
                    : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_dic_dichtung_alternativtext',
                      true
                    )
                  "
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_dic_dichtung_alternativtext',
                      false
                    )
                  "
                ></span>
              </span>
            </span>
            <span class="sugg_stainless">Rostfrei</span>
            <span class="sugg_group">
              <span class="name">Artikelgruppe</span>
              <span
                :class="[
                  'sort',
                  this.currentSortField ==
                  'customFields.yuniqProductProperty_gruppe_artikelgruppe'
                    ? 'active'
                    : '',
                ]"
              >
                <span
                  :class="['asc-button', this.currentSortAsc ? 'active' : '']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_gruppe_artikelgruppe',
                      true
                    )
                  "
                ></span>
                <span
                  :class="['desc-button', this.currentSortAsc ? '' : 'active']"
                  @click="
                    sortList(
                      'customFields.yuniqProductProperty_gruppe_artikelgruppe',
                      false
                    )
                  "
                ></span>
              </span>
            </span>
          </li>
        </ul>

        <ul :class="['result-list']">
          <template v-if="isLoadingList">
            <li class="row spin-wrapper">
              <span class="spinner">
                <svg
                  version="1.1"
                  id="e044922d-8653-4a01-a8bf-eb06d885328c"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 109.7 109.7"
                  style="enable-background: new 0 0 109.7 109.7"
                  xml:space="preserve"
                >
                  <g>
                    <circle class="st0" cx="86.2" cy="24.9" r="11.4" />
                    <path
                      class="st0"
                      d="M108.2,42.2l-0.1-0.1c-0.5-1.9-1.4-3.6-2.8-5c-4.3-4.6-11.6-4.7-16.1-0.4c-3.1,2.9-4.3,7.3-3.1,11.3l0,0
                    c3.7,17.2-7.2,34.2-24.5,38s-34.2-7.2-38-24.5s7.2-34.2,24.5-38c5.1-1.1,10.4-0.9,15.4,0.5l0.2,0.2l0,0l-0.2-0.2
                    c6.1,1.6,12.4-2,14-8.1c1.6-6.1-2-12.4-8.1-14l0,0C40.2-6,10,11.1,2,40.3s9.2,59.4,38.4,67.4c29.2,8,59.4-9.2,67.4-38.4
                    C110.1,60.5,110.3,51.2,108.2,42.2z"
                    />
                  </g>
                </svg>
              </span>
            </li>
          </template>
          <template v-else>
            <li v-if="searchResults.length <= 0" class="no-entries">
              Keine passenden Lager gefunden.
            </li>
            <a
              v-for="suggestion in searchResults"
              :key="suggestion"
              :href="'https://www.sbn.de/detail/' + suggestion.id"
            >
              <li class="row">
                <span class="sugg_desc">{{ suggestion.name }}</span>
                <!-- -->
                <span class="sugg_d">{{
                  suggestion.customFields.yuniqProductProperty_virtuell_innen_d
                    ? Number(
                        suggestion.customFields.yuniqProductProperty_virtuell_innen_d
                      ).toFixed(2)
                    : ""
                }}</span>
                <span class="sugg_D">{{
                  suggestion.customFields.yuniqProductProperty_abm_gross_d
                    ? Number(
                        suggestion.customFields.yuniqProductProperty_abm_gross_d
                      ).toFixed(2)
                    : ""
                }}</span>
                <span class="sugg_B">{{
                  suggestion.customFields.yuniqProductProperty_virtuell_abm_hoehe
                    ? Number(
                        suggestion.customFields.yuniqProductProperty_virtuell_abm_hoehe
                      ).toFixed(2)
                    : ""
                }}</span>
                <!-- -->
                <span class="sugg_flange">{{
                  suggestion.customFields.yuniqProductProperty_m_flansch
                    ? suggestion.customFields.yuniqProductProperty_m_flansch
                    : ""
                }}</span>
                <span class="sugg_seal">{{
                  suggestion.customFields
                    .yuniqProductProperty_dic_dichtung_alternativtext
                    ? suggestion.customFields
                        .yuniqProductProperty_dic_dichtung_alternativtext
                    : ""
                }}</span>
                <span class="sugg_stainless">{{
                  suggestion.customFields.yuniqProductProperty_rostfrei
                    ? suggestion.customFields.yuniqProductProperty_rostfrei
                    : ""
                }}</span>
                <span class="sugg_group">{{
                  suggestion.customFields
                    .yuniqProductProperty_gruppe_artikelgruppe
                    ? suggestion.customFields
                        .yuniqProductProperty_gruppe_artikelgruppe
                    : ""
                }}</span>
              </li>
            </a>
          </template>
        </ul>

        <ul v-if="numberOfPages > 1" class="pagination">
          <li
            :class="[currentPage > 1 ? '' : 'inactive']"
            @click="updateCurrentPage(currentPage - 1)"
          >
            &lt;
          </li>

          <template v-if="numberOfPages < 10">
            <li
              v-for="n in numberOfPages"
              :class="[n == currentPage ? 'active' : '']"
              :key="n"
              @click="updateCurrentPage(n)"
            >
              {{ n }}
            </li>
          </template>
          <template v-else>
            <!-- MORE THAN 9 entries, so we have to omit some -->
            <!-- we'll always show at least three -->

            <li
              v-for="n in 3"
              :class="[n == currentPage ? 'active' : '']"
              :key="n"
              @click="updateCurrentPage(n)"
            >
              {{ n }}
            </li>

            <template v-if="currentPage < 4">
              <li
                v-if="currentPage == 3"
                :key="4"
                @click="updateCurrentPage(4)"
              >
                4
              </li>
              <li class="inactive">…</li>
            </template>
            <template v-else-if="currentPage == 4">
              <li class="active" :key="4" @click="updateCurrentPage(4)">4</li>
              <li :key="5" @click="updateCurrentPage(5)">5</li>
              <li class="inactive">…</li>
            </template>

            <template
              v-else-if="currentPage > 4 && currentPage < numberOfPages - 3"
            >
              <li v-if="currentPage != 5" class="inactive">…</li>
              <li
                :key="currentPage - 1"
                @click="updateCurrentPage(currentPage - 1)"
              >
                {{ currentPage - 1 }}
              </li>

              <li
                class="active"
                :key="currentPage"
                @click="updateCurrentPage(currentPage)"
              >
                {{ currentPage }}
              </li>

              <li
                :key="currentPage + 1"
                @click="updateCurrentPage(currentPage + 1)"
              >
                {{ currentPage + 1 }}
              </li>

              <li v-if="currentPage != numberOfPages - 4" class="inactive">
                …
              </li>
            </template>

            <template v-if="currentPage > numberOfPages - 3">
              <li class="inactive">…</li>
              <li
                v-if="currentPage == numberOfPages - 2"
                :key="numberOfPages - 3"
                @click="updateCurrentPage(numberOfPages - 3)"
              >
                {{ numberOfPages - 3 }}
              </li>
            </template>
            <template v-else-if="currentPage == numberOfPages - 3">
              <li class="inactive">…</li>
              <li
                :key="numberOfPages - 4"
                @click="updateCurrentPage(numberOfPages - 4)"
              >
                {{ numberOfPages - 4 }}
              </li>
              <li
                class="active"
                :key="numberOfPages - 3"
                @click="updateCurrentPage(numberOfPages - 3)"
              >
                {{ numberOfPages - 3 }}
              </li>
            </template>

            <li
              :class="[numberOfPages - 2 == currentPage ? 'active' : '']"
              :key="numberOfPages - 2"
              @click="updateCurrentPage(numberOfPages - 2)"
            >
              {{ numberOfPages - 2 }}
            </li>

            <li
              :class="[numberOfPages - 1 == currentPage ? 'active' : '']"
              :key="numberOfPages - 1"
              @click="updateCurrentPage(numberOfPages - 1)"
            >
              {{ numberOfPages - 1 }}
            </li>

            <li
              :class="[numberOfPages == currentPage ? 'active' : '']"
              :key="numberOfPages"
              @click="updateCurrentPage(numberOfPages)"
            >
              {{ numberOfPages }}
            </li>
          </template>

          <li
            :class="[currentPage == numberOfPages ? 'inactive' : '']"
            @click="updateCurrentPage(currentPage + 1)"
          >
            &gt;
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "../components/BaseInput.vue";
import BaseDropdown from "../components/BaseDropdown.vue";
import BaseMultipleDropdown from "../components/BaseMultipleDropdown.vue";
import RangeWrapper from "../components/RangeWrapper.vue";
import TwoColumnWrapper from "../components/TwoColumnWrapper.vue";
import OneColumnWrapper from "../components/OneColumnWrapper.vue";

export default {
  name: "BearingPicker",
  props: {
    isSearchMode: {
      type: Boolean,
      default: true,
    },
    searchResults: {
      type: Array,
      default: () => [],
    },
    isLoadingList: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    resultLength: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    filterSeal: {
      type: Object,
      default: function () {
        return {
          0: {
            value: "",
            label: "Alle",
            selectedLabel: "Alle",
            isSelectable: true,
          },
        };
      },
    },
    filterCategory: {
      type: Object,
      default: function () {
        return {
          0: {
            value: "",
            label: "Alle",
            selectedLabel: "Alle",
            isSelectable: true,
          },
        };
      },
    },
  },
  components: {
    BaseInput,
    RangeWrapper,
    BaseDropdown,
    BaseMultipleDropdown,
    TwoColumnWrapper,
    OneColumnWrapper,
  },
  data: function () {
    return {
      currentSearchTerm: "",
      currentInnerMin: "",
      currentInnerMax: "",
      currentOuterMin: "",
      currentOuterMax: "",
      currentWidthMin: "",
      currentWidthMax: "",
      currentFlangeSelect: "",
      currentRustSelect: "",
      currentCategoriesSelect: "",
      currentSealSelect: "",
      nextPage: this.currentPage,
      currentSortField: "name",
      currentSortAsc: false,

      yesNoIndexData: {
        options: {
          0: {
            value: "",
            label: "Alle",
            selectedLabel: "Alle",
            isSelectable: true,
          },
          1: {
            value: "Ja",
            label: "Ja",
            selectedLabel: "Ja",
            isSelectable: true,
          },
          2: {
            value: "Nein",
            label: "Nein",
            selectedLabel: "Nein",
            isSelectable: true,
          },
        },
        defaultOptionID: 0,
      },
    };
  },
  methods: {
    selectBearing(id) {
      this.$emit("update:value", id);
      this.isOpenState = false;
    },

    updateInnerMin(value) {
      this.currentInnerMin = value;
      this.nextPage = 1;
    },
    updateInnerMax(value) {
      this.currentInnerMax = value;
      this.nextPage = 1;
    },

    updateOuterMin(value) {
      this.currentOuterMin = value;
      this.nextPage = 1;
    },
    updateOuterMax(value) {
      this.currentOuterMax = value;
      this.nextPage = 1;
    },

    updateWidthMin(value) {
      this.currentWidthMin = value;
      this.nextPage = 1;
    },
    updateWidthMax(value) {
      this.currentWidthMax = value;
      this.nextPage = 1;
    },

    updateSearchTerm(input) {
      this.currentSearchTerm = input;
      this.nextPage = 1;
    },
    updateRust(input) {
      this.currentRustSelect = input;
      this.nextPage = 1;
    },
    updateFlange(input) {
      this.currentFlangeSelect = input;
      this.nextPage = 1;
    },
    updateSeal(input) {
      this.currentSealSelect = input;
      this.nextPage = 1;
    },
    updateCategories(input) {
      this.currentCategoriesSelect = input;      
      this.nextPage = 1;
    },
    updateCurrentPage(pageNumber) {
      this.nextPage = pageNumber;
    },
    sortList(property, isAscending) {
      this.currentSortField = property;
      this.currentSortAsc = isAscending;
    },
  },
  computed: {
    composeSearch: function () {
      if (this.isSearchMode) {
        //fulltext
        return {
          descr: this.currentSearchTerm,
          page: this.nextPage,
        };
      } else {
        let retObj = {
          page: this.nextPage,
        };

        if (this.currentSearchTerm) retObj.descr = this.currentSearchTerm;

        if (this.currentInnerMin) retObj.innerMin = this.currentInnerMin;
        if (this.currentInnerMax) retObj.innerMax = this.currentInnerMax;

        if (this.currentOuterMin) retObj.outerMin = this.currentOuterMin;
        if (this.currentOuterMax) retObj.outerMax = this.currentOuterMax;

        if (this.currentWidthMin) retObj.widthMin = this.currentWidthMin;
        if (this.currentWidthMax) retObj.widthMax = this.currentWidthMax;

        if (this.currentFlangeSelect) retObj.flange = this.currentFlangeSelect;
        if (this.currentRustSelect) retObj.rust = this.currentRustSelect;

        
        if (this.currentCategoriesSelect){
          if(this.currentCategoriesSelect !== "ALL"){
            retObj.categories = this.currentCategoriesSelect;
          }
        } 
          
        if (this.currentSealSelect) retObj.seal = this.currentSealSelect;

        if (this.currentSortField) retObj.sortField = this.currentSortField;
        if (this.currentSortAsc) {
          retObj.sortDirection = "ASC";
        } else {
          retObj.sortDirection = "DESC";
        }

        return retObj;
      }
    },
    numberOfPages: function () {
      return Math.ceil(this.resultLength / this.pageSize);
    },
  },
  watch: {
    composeSearch: function () {
      this.$emit("update:list", this.composeSearch);
    },
  },
  emits: ["update:list", "update:value", "close"],
  mounted() {
    if (this.isSearchMode) {
      this.$refs.fulltext.$el.getElementsByClassName("base-input")[0].focus();
    } else {
      this.$refs.firstparam.$el.getElementsByClassName("base-input")[0].focus();
    }
  },
};
</script>

<style lang="scss">
.bearing-picker {
  width: 100%;
  height: 100%;
  padding: 2rem;
  padding-top: 0;
  box-sizing: border-box;
  margin-top: 2rem;
}
.bearing-search-container {
  display: grid;
  grid-template-columns: 16fr 16fr 16fr 16fr 16fr 16fr;
  grid-template-rows: 6rem 7rem 7rem 1fr;
  grid-column-gap: 2rem;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  @media screen and (max-width: 55rem) {
    padding-top: 2rem;
    grid-template-columns: 100fr;
    grid-template-rows: 16fr;
  }

  .base-button.base-button-cross {
    transform: scale(1.5);
    margin-bottom: 5rem;
    flex-shrink: 0;
    width: 3rem;
    grid-row: 1;
    grid-column: 4;
    justify-content: center;

    @media screen and (max-width: 26rem) {
      transform: scale(1);
      margin-bottom: 2rem;
    }
  }
  .base-input-wrapper {
    width: 100%;
    .base-input {
      min-width: auto;
    }
  }
  > .base-input-wrapper {
    grid-row: 1;
    grid-column: 3 / span 2;
  }

  .range-wrapper {
    margin-bottom: 1rem;
    grid-row: 2;
    &:nth-of-type(1) {
      grid-column: 1 / span 2;
      @media screen and (max-width: 55rem) {
        grid-column: 1;
        grid-row: 2;
      }
    }
    &:nth-of-type(2) {
      grid-column: 3 / span 2;
      @media screen and (max-width: 55rem) {
        grid-column: 1;
        grid-row: 3;
      }
    }
    &:nth-of-type(3) {
      grid-column: 5 / span 2;
      @media screen and (max-width: 55rem) {
        grid-column: 1;
        grid-row: 4;
      }
    }
  }
  .two-col-wrapper {
    margin-bottom: 1rem;
    grid-row: 3;
    &:nth-of-type(4) {
      grid-column: 1 / span 3;
      @media screen and (max-width: 55rem) {
        grid-column: 1;
        grid-row: 5;
      }
    }
    &:nth-of-type(5) {
      grid-column: 4 / span 3;
      @media screen and (max-width: 55rem) {
        grid-column: 1;
        grid-row: 6;
      }
    }
  }
  .one-col-wrapper {
    grid-row: 1;
    grid-column: 1 / span 4;
    .base-input-wrapper .base-input-title{
      display:none;
    }
    @media screen and (max-width: 55rem) {
      grid-column: -1/1;
    }
  }

  @media screen and (max-width: 55rem) {
    .range-wrapper .range-inner {
      justify-content: stretch;
      .range-from,
      .range-to {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 64rem) {
    .base-input-wrapper .base-input {
      font-size: 1rem;
      padding: 1rem;
    }
    .dropdown-button {
      font-size: 1rem;
    }
  }
}

.results {
  grid-column: 1 / span 6;

  width: 100%;

  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 3rem;

  ul {
    padding-left: 0;
  }

  .result-header {
    flex-shrink: 0;
    margin: 0;
    border-bottom: 1px solid $blueDark;

    .grouping {
      color: $blueLight;
    }

    .group_desc {
      width: 13%;
      flex: 13%;
      border-right: 1px solid $blueDark;
      flex-grow: 1;
      @media screen and (max-width: 55rem) {
        width: 20.5%;
        flex: 20.5%;
      }
      @media screen and (max-width: 35rem) {
        width: 25%;
        flex: 25%;
      }
    }

    .group_measurement {
      width: 25.5%;
      flex: 25.5%;
      border-right: 1px solid $blueDark;
      @media screen and (max-width: 55rem) {
        width: 48%;
        flex: 48%;
      }
      @media screen and (max-width: 35rem) {
        width: 75%;
        flex: 75%;
      }
    }

    .group_more {
      width: 61.5%;
      flex: 61.5%;
      @media screen and (max-width: 55rem) {
        width: 31.5%;
        flex: 31.5%;
      }
      @media screen and (max-width: 35rem) {
        display: none;
      }
    }
  }
  .result-list {
    position: relative;
    max-height: 100%;

    box-sizing: border-box;
    width: 100%;
    margin: 0;
    flex-grow: 1;
    overflow: auto;
    margin-bottom: 2rem;

    font-feature-settings: "lnum";

    &::-webkit-scrollbar {
      width: 0.75rem;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 1rem;
    }
    &::-webkit-scrollbar-thumb {
      background: $blueDark;
      border-radius: 1rem;
      border: 1px solid white;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: $blueLight;
    }
  }

  a {
    text-decoration: none !important;
    color: initial;
    &:nth-of-type(2n-1) {
      li {
        background: #e5f3f9;
      }
    }
  }

  li {
    color: $blueDark;
    list-style: none;
    display: flex;
    flex-direction: row;
    letter-spacing: 1px;

    &.no-entries {
      font-weight: 600;
      justify-content: center;
      margin-top: 2rem;
    }

    > span {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    &.header {
      font-size: 1rem;
      font-weight: 600;

      > span {
        padding-bottom: 1rem;
      }

      &.grouping {
        font-size: 1.75rem;
        > span {
          padding-bottom: 2rem;
        }
      }
    }
    &.row {
      font-size: 1rem;
      transition: all 0.25s;
      margin: 0;
      padding-left: 1px;
      @media screen and (max-width: 26rem) {
        font-size: 1rem;
      }
      &.spin-wrapper {
        align-items: center;
        justify-content: center;
        pointer-events: none;
      }
    }

    &.row:hover {
      cursor: pointer;
      color: white;
      background: $blueDark;
      font-weight: bold;
    }

    .sugg_desc {
      width: 13%;
      flex: 13%;
      flex-grow: 1;
      @media screen and (max-width: 35rem) {
        width: 25%;
        flex: 25%;
      }
      span.name {
        max-width: 100%;
        hyphens: auto;
      }
    }

    .sugg_d,
    .sugg_D,
    .sugg_B {
      width: 8.5%;
      flex: 8.5%;
      @media screen and (max-width: 35rem) {
        width: 25%;
        flex: 25%;
      }
    }

    .sugg_flange,
    .sugg_stainless {
      width: 6.5%;
      flex: 6.5%;
      @media screen and (max-width: 55rem) {
        display: none;
      }
    }

    .sugg_seal {
      width: 24.5%;
      flex: 24.5%;
      @media screen and (max-width: 55rem) {
        display: none;
      }
    }

    .sugg_group {
      width: 24%;
      flex: 24%;
      @media screen and (max-width: 35rem) {
        display: none;
      }
    }

    .sugg_B,
    .sugg_desc {
      border-right: 1px solid $blueDark;
    }
  }

  .result-list {
    span {
      border-right: 1px dashed $blueDark;
    }
    .row span:last-child {
      border-right: none;
    }
    a:first-child .row span {
      padding-top: 1.5rem;
    }
  }

  .sort {
    height: 1.25rem;
    transform: translateY(0.5rem);
    width: 1rem;
    display: inline-block;
    position: relative;
    margin-left: 1rem;

    &.disabled {
      display: none;
    }

    &:before {
      content: "";
      display: block;
      background: rgba($blueDark, 0.1);
      height: 2rem;
      width: 2rem;
      border-radius: 100%;
      top: -0.5rem;
      left: -0.5rem;
      position: absolute;
      opacity: 0;
      transition: color 0.5s;
    }

    &:hover:before {
      opacity: 1;
    }

    .asc-button,
    .desc-button {
      width: 0;
      height: 0;
      border-left: 0.33rem solid transparent;
      border-right: 0.33rem solid transparent;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      opacity: 0.5;

      cursor: pointer;
    }

    .asc-button {
      border-bottom: 0.45rem solid $blueDark;
      top: 0;
    }

    .desc-button {
      border-top: 0.45rem solid $blueDark;
      top: 0.5rem;
    }

    &.active .active {
      opacity: 1;
    }
  }
}

.search-fulltext .results {
  grid-row: 3 / span 3;
}
.search-attrib .results {
  grid-row: 4;
  @media screen and (max-width: 55rem) {
    grid-column: 1;
    grid-row: 7;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  row-gap: 10px;
  li {
    border: 1px solid $blueDark;
    padding: 0.5rem;
    margin-right: 0.5rem;
    margin-bottom: 0;
    font-weight: bold;
    cursor: pointer;

    width: 2.25rem;
    justify-content: center;

    &:hover,
    &.active {
      background: $blueDark;
      color: white;
    }
    &.active {
      cursor: default;
    }
    &.inactive {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

.st0 {
  fill: #009fe3;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinner {
  font-size: 8rem;
  animation: spin 1s linear infinite;
  &,
  svg {
    width: 1em;
    height: 1em;
  }
}

[data-pretitle] {
  position: relative;
  &:before {
    content: attr(data-pretitle);
    position: absolute;
    color: $blueDark;
    top: -1.5rem;
    font-weight: 600;
  }
}
</style>
